var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnderwear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 24,
    viewBox: "0 0 46 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.878049C0 0.393116 0.391042 0 0.873418 0H45.1266C45.609 0 46 0.393116 46 0.878049V12C46 12.3099 45.8375 12.5968 45.5725 12.755L26.9396 23.8769C26.8046 23.9575 26.6506 24 26.4937 24H19.5063C19.3494 24 19.1954 23.9575 19.0604 23.8769L0.427504 12.755C0.162467 12.5968 0 12.3099 0 12V0.878049ZM1.74684 1.7561V4.09756H44.2532V1.7561H1.74684ZM44.2532 5.85366H1.74684V11.0786C2.96952 11.055 4.59855 11.1476 6.33265 11.4735C8.56043 11.8922 11.0333 12.7091 13.043 14.2244C16.563 16.8784 19.0056 20.3923 20.0314 22.2439H25.9917C27.3605 19.8854 29.5929 16.1922 33.6727 14.1415C36.955 12.4916 41.4977 11.5215 44.2532 11.2033V5.85366ZM40.7416 13.5962C38.6196 14.0767 36.3003 14.7841 34.4539 15.7122C32.0838 16.9035 30.4061 18.7341 29.1458 20.5177L40.7416 13.5962ZM16.7628 20.4632L4.14976 12.9345C4.74087 12.9928 5.36784 13.0787 6.01166 13.1997C8.09273 13.5908 10.2781 14.3348 11.9949 15.6293C13.9704 17.1187 15.5865 18.9089 16.7628 20.4632Z",
    fill: "url(#paint0_linear_3687_1972)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3687_1972",
    x1: 5.94228e-7,
    y1: 26.5714,
    x2: 45.6031,
    y2: 7.2157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#7DA1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645919,
    stopColor: "#E16CB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999152,
    stopColor: "#E65B8B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderwear);
export default __webpack_public_path__ + "static/media/underwear.fa4235e20d932396a6dd592ad13977e8.svg";
export { ForwardRef as ReactComponent };